import { DecimalPipe } from '@angular/common';
import { Component, input, inject } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { AppIconService, IconWithTextComponent, SkeletonLoadingComponent } from '@pflegix/ui';

@Component({
  selector: 'pfx-rating-summary-ui',
  imports: [IconWithTextComponent, SkeletonLoadingComponent, DecimalPipe],
  template: `
    <pfx-icon-with-text [icon]="icons.rating">
      @if (loading()) {
        <pfx-skeleton-loading style="width: 150px; height: 10px"></pfx-skeleton-loading>
      } @else {
        <pfx-icon-with-text
          [icon]="icons.ratingInbound"
          class="mr-4"
          >{{ inboundRating() | number: '1.1-1' }} ({{ inboundCount() }})</pfx-icon-with-text
        >
        <pfx-icon-with-text [icon]="icons.ratingOutbound"
          >{{ outboundRating() | number: '1.1-1' }} ({{ outboundCount() }})</pfx-icon-with-text
        >
      }
    </pfx-icon-with-text>
  `,
})
export class RatingSummaryUIComponent {
  private readonly appIconService = inject(AppIconService);

  public inboundRating = input<number>(0);

  public inboundCount = input<number>(0);

  public outboundRating = input<number>(0);

  public outboundCount = input<number>(0);

  public loading = input<boolean>(true);

  public get icons(): {
    rating: IconDefinition;
    ratingInbound: IconDefinition;
    ratingOutbound: IconDefinition;
  } {
    return {
      rating: this.appIconService.getRatingIcon('DEFAULT').icon,
      ratingInbound: this.appIconService.getRatingIcon('inbound').icon,
      ratingOutbound: this.appIconService.getRatingIcon('outbound').icon,
    };
  }
}
